import { jsx as _jsx } from "react/jsx-runtime";
import { Form, InputNumber } from 'antd';
var FormInputNumber = function (props) {
    return (_jsx(Form.Item, { label: props.label, name: props.name, className: props.formClasses || 'form-item body---14pt-R', rules: props.rules, hasFeedback: true, initialValue: props.initialValue, children: _jsx(InputNumber, { className: props.inputClasses || 'input-border number-input', placeholder: props.placeHolder, onChange: props.onChange, min: props.min, max: props.max, bordered: props.bordered, addonAfter: props.addonAfter }) }));
};
export default FormInputNumber;
